import React from 'react';
import { Container, Sprite, Text } from '@pixi/react';
import { isMobile } from '../../../core/helpers/isMobile';
import { introService } from '../../../services/introService';
import { userSettingsStore } from '../../../store/userSettingsStore';

function IntroContent({
  canvasTranslationKeys,
  check,
  button,
  checkbox,
  introCheckboxState,
  setIntroCheckboxState,
}) {
  return (
    <Container name='IntroContent'>
      <Container
        x={isMobile() ? 120 : 550}
        y={isMobile() ? 750 : 700}
        pointerup={() => {
          introService.resetIntro();
          if (introCheckboxState) {
            userSettingsStore.setShowIntro();
          }
          userSettingsStore.updateIsShowIntro(false);
        }}
        interactive
        cursor='pointer'
      >
        <Sprite texture={button} />
        <Text
          text={canvasTranslationKeys.PLAY_INTRO}
          x={110}
          y={22}
          resolution={2}
          cursor='pointer'
          style={{
            align: 'center',
            wordWrap: true,
            wordWrapWidth: 620,
            fill: '#FFFFFF',
            fontWeight: 400,
            fontSize: isMobile() ? 25 : 30,
            fontFamily: 'alfaSlabOneRegular',
          }}
        />
      </Container>

      <Container x={isMobile() ? 160 : 1114} y={isMobile() ? 880 : 756}>
        <Sprite
          texture={checkbox}
          interactive
          cursor='pointer'
          anchor={0.5}
          y={15}
          pointerup={() => {
            setIntroCheckboxState(!introCheckboxState);
          }}
        />
        <Sprite texture={check} anchor={0.5} y={15} x={7} visible={introCheckboxState} />
        <Text
          text={canvasTranslationKeys.DONT_SHOW_AGAIN}
          x={20}
          y={isMobile() ? 4 : 7.5}
          resolution={2}
          style={{
            align: 'center',
            wordWrap: true,
            wordWrapWidth: 620,
            fill: '#FFFFFF',
            fontWeight: 400,
            fontSize: isMobile() ? 22 : 17,
            fontFamily: 'Arial',
          }}
        />
      </Container>
    </Container>
  );
}
export default IntroContent;
